import { USER_SEARCH_SUCCESS, USER_SEARCH_ERROR } from '../constants';

const initState = {
  searchResults: []
};

const signupModalReducer = (state = initState, action) => {
  switch (action.type) {
    case USER_SEARCH_SUCCESS:
      return {
        ...state,
        searchResults: [...action.payload]
      };
    case USER_SEARCH_ERROR:
      return {
        ...state,
        searchResults: []
      };
    default:
      return state;
  }
};

export default signupModalReducer;



// WEBPACK FOOTER //
// ./src/store/reducers/searchResultsReducer.js